<div class="process-logs-loader">
  <div class="process-logs-timeline" *ngIf="showTimeline" #logsContainer>
    <div
      class="process-log-row is-completed"
      *ngFor="let evaluation of completedEvaluations"
    >
      <div class="process-log-rail">
        <span class="process-log-dot"></span>
      </div>
      <div class="process-log-text">{{ evaluation }}</div>
    </div>

    <div class="process-log-row is-live" *ngIf="liveThinkingText as thinkingText">
      <div class="process-log-rail">
        <div class="mat-spinner-wrap" *ngIf="isActive && !isError">
          <mat-spinner diameter="14"></mat-spinner>
        </div>
        <img
          *ngIf="!isActive || isError"
          class="process-log-icon"
          src="assets/images/virtusa-icons/thinking_icon.svg"
          alt="thinking"
        />
      </div>
      <div class="process-log-text">{{ thinkingText }}</div>
    </div>
  </div>

  <div class="process-logs-footer">
    <div class="status-label">{{ statusLabel }}</div>
    <div class="gradient-loader" *ngIf="showLoader" [class.is-active]="isActive && !isError" [class.is-error]="isError">
      <div class="gradient-loader-bar"></div>
    </div>
  </div>
</div>
